import { render, staticRenderFns } from "./spuAttributes.vue?vue&type=template&id=601271fd&scoped=true&"
import script from "./spuAttributes.vue?vue&type=script&lang=js&"
export * from "./spuAttributes.vue?vue&type=script&lang=js&"
import style0 from "./spuAttributes.vue?vue&type=style&index=0&id=601271fd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601271fd",
  null
  
)

export default component.exports